import * as React from 'react';

export const Dashboard = () => (
  <div className="card">
    <div className="card-body">
      <h1 className="card-title">Dashboard</h1>
    </div>
  </div>
);
